import React from 'react';
import TypedReact from './TypedReact'

const hero = () => {
  return (
    <div>
      <section id="hero" className="d-flex align-items-center">
        <div className="container d-flex flex-column align-items-center" data-aos="zoom-in" data-aos-delay="100">
        <h1>Sam Y. Kim</h1>
        <TypedReact strings={['Co-Founder','Patent Litigator','Developer']}/>
        </div>
      </section>
    </div>
  );
}

export default hero;


// WEBPACK FOOTER //
// ./src/components/Hero.js